<template>
  <div class="exam-page">
    <div class="exam-container">
      <div>
        <img src="/img/icons/materi.svg" width="65" />
          <a href='https://alfathbelajar.com/subject'>
          <my-button type="teal" class="mt-3" block>
            <fa-icon icon="check-circle" class="mr-1"></fa-icon>
            Pilih Materi Disini
          </my-button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as types from "../store/types";
export default {
  data() {
    return {
      startModal: false,
      pagination: []
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN
    })
  },
  mounted() {
    if (!this.isLoggedIn) {
      this.$router.push("/login");
    }
  }
};
</script>

<style>
.dashboard-page {
  padding: 33px;
}

.dashboard-page {
  padding: 33px;
}

.exam-container {
  height: calc(100vh - 140px);
  background-image: linear-gradient(
    59deg,
    #56c8ff 1%,
    #2190e9 53%,
    #00cbae 114%
  );

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
}
</style>